import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import storageApi from 'src/api/storage'

export const getOrFilterPurchasesRecord = createAsyncThunk(
     'storage/getOrFilterProductRecord ',
    async (query) => {
      const response = await storageApi.getOrFilterPurchasesRecord(query)
      return response
    }
)

const initialState = {
  status:'',
  purchaseRecord:[],
  loading: true,
  error:'',
}

const slice = createSlice({
  name: 'purchasesRecord',
  initialState,
  reducers: {
    setProductRecord(oldState,action){
        let newProductRecord=action.payload;
        oldState.purchaseRecord=newProductRecord
    },
    setFilter(oldState, action){
      oldState.filter=action.payload
    },
    setFilterProps(oldState,action){
        let newProps=action.payload;
        oldState.filterProps=newProps
    },
 
  },
  extraReducers: {
    [getOrFilterPurchasesRecord.pending]: (state, action) => {
        state.status = 'loading'
        state.loading = true
    },
    [getOrFilterPurchasesRecord.fulfilled]: (state, action) => {
        state.status = 'succeeded'
        state.purchaseRecord = action.payload.content
        state.loading = false;
    },
    [getOrFilterPurchasesRecord.rejected]: (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
    }
}

})

export const reducer = slice.reducer


export default slice
